import parse from 'date-fns/parse';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import timeZoneData from './timezones.json';

export const defaultTimeSlot = [
  {
    day: 0,
    to: '',
    from: '',
    valid: false,
  },
  {
    day: 1,
    to: '',
    from: '',
    valid: false,
  },
  {
    day: 2,
    to: '',
    from: '',
    valid: false,
  },
  {
    day: 3,
    to: '',
    from: '',
    valid: false,
  },
  {
    day: 4,
    to: '',
    from: '',
    valid: false,
  },
  {
    day: 5,
    to: '',
    from: '',
    valid: false,
  },
  {
    day: 6,
    to: '',
    from: '',
    valid: false,
  },
];

export const generateTimeSlots = (step = 15) => {
  /* Smartor: Generates a list of time strings from 00:00 to 23:45 in 24-hour format.
   * Each new string will be generated by adding `step` minutes.
   */
  const date = new Date(1970, 1, 1, 0, 0, 0); // Start at 00:00
  const slots = [];
  const endTime = new Date(1970, 1, 2, 0, 0, 0); // End at next day 00:00

  while (date.getTime() < endTime.getTime()) { // Loop until end of day
    slots.push(
      date.toLocaleTimeString([], { // Use browser locale for 24-hour
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // <-- Changed to false for 24-hour format
      })
    );
    date.setMinutes(date.getMinutes() + step);
  }

  // Always add 11:59 PM as the final slot if it's not already included
  const lastSlot = '11:59 PM';
  if (!slots.includes(lastSlot)) {
    slots.push(lastSlot);
  }

  return slots;
};

export const getTime = (hour, minute) => {
  // הסרנו את חישובי AM/PM
  const parsedHour = hour < 10 ? `0${hour}` : hour; // השתמש בשעה המלאה (0-23)
  const parsedMinute = minute < 10 ? `0${minute}` : minute;
  return `${parsedHour}:${parsedMinute}`; // הסרנו את ה-merdian
};

export const timeSlotParse = timeSlots => {
  return timeSlots.map(slot => {
    const {
      day_of_week: day,
      open_hour: openHour,
      open_minutes: openMinutes,
      close_hour: closeHour,
      close_minutes: closeMinutes,
      closed_all_day: closedAllDay,
      open_all_day: openAllDay,
    } = slot;
    const from = closedAllDay ? '' : getTime(openHour, openMinutes);
    const to = closedAllDay ? '' : getTime(closeHour, closeMinutes);

    return {
      day,
      to,
      from,
      valid: !closedAllDay,
      openAllDay,
    };
  });
};

export const timeSlotTransform = timeSlots => {
  return timeSlots.map(slot => {
    const closed = slot.openAllDay ? false : !(slot.to && slot.from);
    const openAllDay = slot.openAllDay;
    let fromDate = '';
    let toDate = '';
    let openHour = '';
    let openMinutes = '';
    let closeHour = '';
    let closeMinutes = '';

    if (!closed) {
      // שינוי כאן כדי לנתח פורמט 24 שעות
      fromDate = parse(slot.from, 'HH:mm', new Date()); 
      toDate = parse(slot.to, 'HH:mm', new Date());
      openHour = getHours(fromDate);
      openMinutes = getMinutes(fromDate);
      closeHour = getHours(toDate);
      closeMinutes = getMinutes(toDate);
    }

    return {
      day_of_week: slot.day,
      closed_all_day: closed,
      open_hour: openHour,
      open_minutes: openMinutes,
      close_hour: closeHour,
      close_minutes: closeMinutes,
      open_all_day: openAllDay,
    };
  });
};

export const timeZoneOptions = () => {
  return Object.keys(timeZoneData).map(key => ({
    label: key,
    value: timeZoneData[key],
  }));
};